// Recepção do Campus: saguão de porcelanato, área de espera de madeira à esquerda e um sofá
// à direita. O balcão fica no alto; a equipe fica em pé do lado de dentro (ponto acima do
// balcão) e os visitantes entram pela porta de baixo.

import type { RoomMap } from '../../core/world.js';

export const RECEPCAO: RoomMap = {
  id: 'recepcao',
  kind: 'reception',
  name: 'Recepção',
  // p = porcelanato (saguão), m = madeira (espera)
  floor: [
    'pppppppppppppp',
    'pppppppppppppp',
    'pppppppppppppp',
    'mmmmmppppppppp',
    'mmmmmppppppppp',
    'mmmmmppppppppp',
    'mmmmmppppppppp',
    'mmmmmppppppppp',
    'pppppppppppppp',
  ],
  legend: { p: 'porcelanato', m: 'madeira' },
  items: [
    // parede norte: janelas, placas, relógio e ar-condicionado
    { item: 'janela', x: 1, y: 0 },
    { item: 'relogio', x: 4, y: 0 },
    { item: 'quadro-avisos', x: 6, y: 0 },
    { item: 'poster-agzos', x: 8, y: 0 },
    { item: 'ar-condicionado', x: 10, y: 0 },
    { item: 'janela', x: 12, y: 0 },
    // canto de cima: plantas, luminária, impressora e cabideiro
    { item: 'planta-grande', x: 0, y: 1 },
    { item: 'luminaria-chao', x: 0, y: 2 },
    { item: 'impressora', x: 3, y: 2 },
    { item: 'balcao-recepcao', x: 4, y: 2 },
    { item: 'cabideiro', x: 13, y: 1 },
    // espera à esquerda: sofá e mesa de centro
    { item: 'sofa-espera', x: 1, y: 4 },
    { item: 'mesa-centro', x: 1, y: 5 },
    // espera à direita, com o totem da Agzos
    { item: 'sofa-espera', x: 9, y: 5 },
    { item: 'mesa-centro', x: 9, y: 6 },
    { item: 'totem-agzos', x: 12, y: 6 },
    { item: 'bebedouro', x: 13, y: 4 },
    // cantos de baixo e caixas de entrega perto da porta
    { item: 'planta-vaso', x: 0, y: 8 },
    { item: 'caixas-papelao', x: 10, y: 8 },
    { item: 'vaso-alto', x: 13, y: 8 },
  ],
  doors: [{ x: 7, y: 8 }],
};
